export const LABELS = {
  TITLE: 'New invitation!',
  SUBTITLE: 'Someone has invited you to complete your profile and join their group application',
  BUTTON: 'Accept invite',
};
